module.exports = __webpack_public_path__ + "static/media/control.2d4377a2.mp3";